import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const employeeCheckinRoutes = {
  name: 'pick-employees',
  path: 'employee-checkin',
  component: () => import('./EmployeeCheckin.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
